/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 171);
/******/ })
/************************************************************************/
/******/ ({

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common__);

/*
    Code here for
        Sign up jade
        Ask-An-Evangelist
        Admin Site
 */

'use strict';

window.onLoadSignup = function (csrf) {
  var ui_csrf = csrf;
  $('#country').dropdown({
    source: function source(response) {
      $.getJSON('/javascripts/countries.json', function (data) {
        //In this example the Structure the data with val, label syntax is done on the server
        //{value: 'AL', label:'Alabama'}
        response(data);
      });
    }
  }); // Copy the tooltip setting to the new combo box.

  $("#country").closest(".k-combobox").attr("data-tooltip", $("#country").attr("data-tooltip")); // Initialize the tooltips.

  var tooltip = $(".signup-section").kendoTooltip({
    filter: "[data-tooltip]",
    content: kendo.template("#=target.data('tooltip')#"),
    width: 250,
    position: "right"
  }).data("kendoTooltip");
  $(".signup-section [data-tooltip]").focus(function () {
    tooltip.show($(this));
  }).blur(function () {
    tooltip.hide();
  });
  $(".appx-agreement").click(function () {
    var htmlStr = '<iframe src="/user/assets/infor-nexus-developer-network-TOS" />';
    $('body').message({
      title: 'Appx Agreement',
      message: htmlStr,
      cssClass: 'terms-modal',
      buttons: [{
        text: 'Close',
        click: function click() {
          $(this).modal('close');
        },
        isDefault: true
      }]
    });
  });
  $("#username").focus();
  $('#createAccount').click(function (e) {
    $('.button-line').busyindicator({
      text: 'Completing Sign up...',
      displayDelay: 0
    }).trigger('start.busyindicator');
    $.post(location.href, {
      _csrf: ui_csrf,
      firstName: $('#firstName').val(),
      lastName: $('#lastName').val(),
      email: $('#email').val(),
      email2: $('#email2').val(),
      organization: $('#organization').val(),
      jobTitle: $('#jobTitle').val(),
      progLangs: $('#progLangs').val(),
      country: $('#country').val(),
      agreement: $('#agreement').val(),
      'g-recaptcha-response': $('#g-recaptcha-response').val()
    }, 'json').done(function () {
      __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displaySuccessMessage('Sign Up Complete', 'You have signed up successfully. You will soon receive an e-mail with detailed information on how to access your sandbox environment.', function () {
        location.href = '/';
      });
    }).fail(function (jqXHR) {
      var response = jqXHR.responseJSON;

      if (response && response.errors) {
        __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displayUserErrors(response.errors);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displayUserErrors([{
          message: 'Unknown Error - Please alert the Evangelism team at Infor Nexus'
        }]);
      }
    }).always(function () {
      $('.button-line').busyindicator().trigger('updated.busyindicator');
    });
  });
};

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.initializeAceEditorPane = function () {
  var containers = document.getElementsByClassName('tab-panel');

  __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.aceEditorFocusOut = function (e) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = containers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var tabPanel = _step.value;
        tabPanel.classList.remove('gtn-onFocus');
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.aceEditorFocus = function (e) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = containers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var tabPanel = _step2.value;
        tabPanel.classList.add('gtn-onFocus');
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  };
};

function initializeAceEdit(id, mode) {
  if (!__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.aceEditorFocusOut) {
    __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.initializeAceEditorPane();
  }

  var aceEdit = ace.edit(id);
  aceEdit.getSession().setMode(mode);
  aceEdit.session.setUseWorker(false);
  aceEdit.on('focus', __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.aceEditorFocus);
  aceEdit.on('blur', __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.aceEditorFocusOut);
  return aceEdit;
}

window.onLoadAskAnEvangelist = function (csrf) {
  var ui_csrf = csrf;
  $('#topic').dropdown({
    source: function source(response) {
      $.getJSON('/javascripts/website-topics.json', function (data) {
        //In this example the Structure the data with val, label syntax is done on the server
        //{value: 'AL', label:'Alabama'}
        response(data);
      });
    }
  });
  $('.tab-container').tabs();
  $('#submitQuestion').click(function (e) {
    $('.button-line').busyindicator({
      text: 'Submitting Question...',
      displayDelay: 0
    }).trigger('start.busyindicator');
    var payload = {
      _csrf: ui_csrf,
      name: $('#firstName').val() + " " + $('#lastName').val(),
      topic: $('#topic').val(),
      email: $('#email').val(),
      question: $('#question').val(),
      html: hEditor.getValue(),
      javascript: jEditor.getValue(),
      referral_url: document.referrer,
      json: jsonEditor.getValue(),
      'g-recaptcha-response': $('#g-recaptcha-response').val()
    };
    $.post('/user/ask-an-evangelist', payload, "json").done(function () {
      __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displaySuccessMessage('Question Submitted', 'Your question has been emailed to a Infor Nexus Evangelist. You should receive a response by the end of the next business day. Thanks for contributing to the AppXpress Community', function () {
        window.history.go(-1);
      });
    }).fail(function (res) {
      var response = res.responseJSON;

      if (response && response.errors) {
        __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displayUserErrors(response.errors);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displayUserErrors([{
          message: 'Unknown Error - Please alert the Evangelism team at Infor Nexus'
        }]);
      }
    }).always(function () {
      $('.button-line').busyindicator().trigger('updated.busyindicator');
    });
  }); // Initialize the tooltips.

  var tooltip = $(".article-content").kendoTooltip({
    filter: "[data-tooltip]",
    content: kendo.template("#=target.data('tooltip')#"),
    width: 250,
    position: "right"
  }).data("kendoTooltip");
  $(".article-content [data-tooltip]").focus(function () {
    tooltip.show($(this));
  }).blur(function () {
    tooltip.hide();
  });
  var hEditor = initializeAceEdit("htmlEditor", "ace/mode/html");
  var jEditor = initializeAceEdit('jsEditor', "ace/mode/javascript");
  var jsonEditor = initializeAceEdit("jsonEditor", 'ace/mode/json');
};

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin = {};
/*
 Show a popup on the screen that displays the user errors
 ServerErrors should be an array of errors with a message field to alert the user
 */

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displayUserErrors = function (serverErrors) {
  var htmlString = 'Form has the following errors:<ul>';

  if (serverErrors) {
    serverErrors.forEach(function (item) {
      htmlString += '<li>' + item.message + '</li>';
    });
  } else {
    console.err('Display User Errors function requires an array of error with messages');
  }

  htmlString += '</ul>';
  $('body').message({
    title: 'Form Submission Error',
    message: htmlString,
    isError: true,
    buttons: [{
      text: 'Ok',
      click: function click() {
        $(this).modal('close');
      },
      isDefault: true
    }]
  });
};
/*
 Display a success message
 Optionally, display a success title - default will be Success
 Optionally, add a redirectUrl - if added, will redirect the user on close of modal
 */


__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displaySuccessMessage = function (successTitle, successMsg, closeFn) {
  $('body').message({
    title: successTitle ? successTitle : 'Success',
    isSuccess: true,
    message: successMsg ? successMsg : 'Form submission successful',
    buttons: [{
      text: 'Ok',
      click: function click() {
        $(this).modal('close');

        if (closeFn) {
          closeFn();
        }
      },
      isDefault: true
    }]
  });
};

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.populateQuestionIntoDOM = function (doc) {
  var $div = $('#questiondiv').show();
  __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.sendToEmail = doc.email;
  $('#nameValue').text(doc.name);
  $('#topicValue').text(doc.topic);
  $('#questionValue').text(doc.question);
  $('#readyState').val(doc.ready).trigger('updated');
  $('#subtopic').val(doc.subtopic);
  $('#answer').val(doc.answer);

  if (doc.tags) {
    $('#questionTags').val(doc.tags).trigger('updated');
  } else {
    $('#questionTags').val([]).trigger('updated');
  }

  ace.edit("htmlEditor").setValue(doc.answerHtml, 1);
  ace.edit('jsEditor').setValue(doc.answerJavascript, 1);
  ace.edit('jsonEditor').setValue(doc.answerJson, 1); //IF question already answered, alert USER

  if (doc.ready == 0) {
    __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.sendEmailOnSubmit = true;
  } else {
    var $msg = $('<p/>').addClass('m-page-summary-alert').html(' <b>Alert</b> : Question has already been answered. You can edit the answer' + ' to the question. Press SAVE at the button to save your changes. Be aware that an email will NOT be resent.');
    $div.prepend($msg); //Change label of submit button to

    $('#submitQuestion').val('SAVE');
    __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.sendEmailOnSubmit = false;
  }

  var $codeDiv = $('#questionCodeSnippets');

  if (doc.javascriptCode && doc.javascriptCode != "") {
    var $jsHeader = $('<h4/>').text('Javascript Code');
    var $codeBlock = $('<pre\>');
    var $jsCode = $('<code/>').addClass('language-javascript').append(doc.javascriptCode);
    $codeBlock.append($jsCode);
    $codeDiv.append($jsHeader).append($codeBlock);
  }

  if (doc.htmlCode && doc.htmlCode != "") {
    var $htmlHeader = $('<h4/>').text('Markup Code');
    var $htmlCodeBlock = $('<pre\>');
    var $htmlCode = $('<code/>').addClass('language-markup').text(doc.htmlCode);
    $htmlCodeBlock.append($htmlCode);
    $codeDiv.append($htmlHeader).append($htmlCodeBlock);
  }

  if (doc.jsonCode && doc.jsonCode != "") {
    var $jsonHeader = $('<h4/>').text('JSON');
    var $jsonCodeBlock = $('<pre\>');
    var $jsonCode = $('<code/>').addClass('language-json').text(doc.jsonCode);
    $jsonCodeBlock.append($jsonCode);
    $codeDiv.append($jsonHeader).append($jsonCodeBlock);
  }

  Prism.highlightAll();
};

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.editForumQuestionInit = function () {
  $('#topic').dropdown({
    source: function source(response) {
      $.getJSON('/javascripts/website-topics.json', function (topics) {
        response(topics);
      });
    }
  });
  $('#searchBtn').click(function () {
    $('table > tbody').empty();
    $.get('/user/mongo/GetQuestions', {
      topic: $('#topic').val(),
      keywords: $('#keywords').val(),
      offset: 0,
      limit: 20,
      admin: true
    }).done(function (data) {
      __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.populateAdminLookupTable(data);
    });
  });
};

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.answerQuestionInit = function (csrf) {
  $(".tab-container").tabs();
  $('#submitQuestion').click(function (e) {
    var payload = {
      _csrf: csrf,
      subtopic: $('#subtopic').val(),
      answer: $('#answer').val(),
      ready: $('#readyState').val(),
      html: hEditor.getValue(),
      question: $('#questionValue').text(),
      javascript: jEditor.getValue(),
      json: jsonEditor.getValue(),
      id: __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.questionId,
      sendEmail: __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.sendEmailOnSubmit,
      name: $('#nameValue').text(),
      email: __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.sendToEmail,
      tags: JSON.stringify($('#questionTags').val())
    };
    $.post('/admin/mongo/saveQuestionAnswer', payload, "json").done(function () {
      console.log('success'); //Open popover

      __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displaySuccessMessage('Question Submitted', 'Question was successfully answered and saved to database', function () {
        $('.m-page-summary-alert').remove();
        $('#questiondiv').hide();
      });
    }).fail(function (xhr, status, err) {
      if (xhr.responseJSON) {
        var errors = xhr.responseJSON.errors;
        __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.ui.displayUserErrors(xhr.responseJSON.errors);
      } else {
        alert('ERROR ON SERVER !');
      }
    });
  });
  var hEditor = initializeAceEdit("htmlEditor", "ace/mode/html");
  var jEditor = initializeAceEdit('jsEditor', "ace/mode/javascript");
  var jsonEditor = initializeAceEdit("jsonEditor", 'ace/mode/json');
  $("#findQuestionBtn").click(function () {
    __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.questionId = $('#questionId').val();
    $('.m-loading-spinner').show();
    $('#questionCodeSnippets').empty();
    $.get('/admin/mongo/fetchQuestionById', {
      id: __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.questionId
    }).done(function (document) {
      console.log('success');
      console.log(document); //gtn.page.addQuestionHtml(document);

      __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.populateQuestionIntoDOM(document);
    }).fail(function () {
      alert("Couldn't find a question with this ID");
    }).always(function () {
      $('.m-loading-spinner').hide();
    });
  });
  $('#readyState').dropdown();
  $('#questionTags').multiselect({
    source: function source(setFn) {
      $.getJSON('/javascripts/question-tags.json', function (tags) {
        setFn(tags);
      });
    }
  }).trigger('load.dropdown.source');
  var id = location.search.split('id=')[1];

  if (id) {
    $('#questionId').val(id);
    $('#findQuestionBtn').click();
  }
};

__WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin.populateAdminLookupTable = function (data) {
  var $table = $('table');
  var $tr, $td;

  data._result.forEach(function (item, indx) {
    $tr = $('<tr/>');
    $td = $('<td/>').html('<a href="/admin/answer-forum-question?id=' + item._id + '">Link</a>');
    $tr.append($td);
    $td = $('<td/>').text(item.subtopic);
    $tr.append($td);
    $td = $('<td/>').text(item.question);
    $tr.append($td);
    $table.append($tr);
  });
};

window.gtn_admin = __WEBPACK_IMPORTED_MODULE_0__GTNexus_Common___default.a.admin;

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

// Declare the application's top-level namespaces.
var gtn = gtn || {};
gtn.text = gtn.text || {}; // namespace for generic text-manipulation utilities.

gtn.ui = gtn.ui || {}; // namespace for generic UI-manipulation utilities.

gtn.page = gtn.page || {}; // namespace for page-specific functions.
// Disable AJAX caching on localhost (to facilitate editing). Enable it for production.

gtn.ajaxCache = location.hostname == "localhost" ? false : true;
gtn.currentHash = location.hash;

gtn.getHash = function () {
  // Currently only supports version number and article section.
  var hash = location.hash;
  var hashObj = {
    version: "",
    section: ""
  };

  if (hash && hash.substring(0, 3) == "#!/") {
    var values = hash.substring(3).split("/");
    $.each(values, function (index, value) {
      if (value.substring(0, 8) == "version:") {
        // version number.
        hashObj.version = value.substring(8);
      } else {
        // article section.
        hashObj.section = value;
      }
    });
  }

  return hashObj;
};

gtn.setHash = function (field, value) {
  // Currently only supports version number and article section.
  var hashObj = gtn.getHash();

  if (field == "version") {
    // When version is being set (i.e. changed), discard the section value.
    hashObj.version = value;
    hashObj.section = "";
  } else {
    // When article section is being set, retain the version value.
    hashObj.section = value;
  } // Serialize the hash object into string.


  var hash = hashObj.version ? "/version:" + hashObj.version : "";
  hash += hashObj.section ? "/" + hashObj.section : "";
  gtn.currentHash = hash ? "#!" + hash : ""; // Record the hash in a global variable, so later we can distinguish
  // between hash change trigger by code and hash change trigger by user entry.

  location.hash = gtn.currentHash;
}; //Unused


gtn.ui.processIcons = function () {
  gtn.ui.myBookmarksMode = $(".m-main-content").hasClass("my-bookmarks");

  if (!gtn.ui.myBookmarksMode) {
    $(".article-title, .section-title").before("<div class='icon-menu'></div>");
  }

  $(".icon-menu").html("<div></div><div></div><div></div>");
  $(".icon-bookmark").html("<div class='bottom-notch'></div></div><div>");
  $(".icon-note").each(function () {
    // Save the note content as a data attribute, because the html will be dynamically changed.
    var content = $(this).html();
    $(this).data("content", content);

    if (gtn.ui.myBookmarksMode) {
      // Display the content directly.
      $(this).html("<div class='left-notch'></div><div>" + $(this).data("content") + "</div>");
    } else {
      // Hide the content and display the collapsed icon.
      $(this).html("<div class='left-notch'></div><div></div><div></div><div></div>");
    }
  }).mouseenter(function () {
    if (!$(this).hasClass("expanded")) {
      $(this).addClass("expanded").html("<div class='left-notch'></div><div>" + $(this).data("content") + "</div>");
    }
  }).mouseleave(function () {
    if (!gtn.ui.myBookmarksMode) {
      $(this).removeClass("expanded").html("<div class='left-notch'></div><div></div><div></div><div></div>");
    }
  });
};

gtn.ui.setTreePointer = function (e) {
  var offsetFromTreeTop = $(e.node).offset().top - $("#topicTree").offset().top;
  $(".tree-pointer").css({
    top: offsetFromTreeTop,
    visibility: "visible"
  });
};

gtn.ui.setBookmarkCheckbox = function (e) {
  // Cancel the default "select" action that highlights the text.
  e.preventDefault(); // Instead, use the action to toggle the checked state of the checkbox.

  var $checkbox = $(e.node).find(":checkbox");
  $checkbox.prop("checked", !$checkbox.prop("checked"));
}; // http://stackoverflow.com/questions/754607/can-jquery-get-all-css-styles-associated-with-an-element/6416527#6416527


$.fn.getStyleObject = function () {
  var dom = this.get(0);
  var style;
  var returns = {};

  if (window.getComputedStyle) {
    var camelize = function camelize(a, b) {
      return b.toUpperCase();
    };

    style = window.getComputedStyle(dom, null);

    for (var i = 0, l = style.length; i < l; i++) {
      var prop = style[i];
      var camel = prop.replace(/\-([a-z])/g, camelize);
      var val = style.getPropertyValue(prop);
      returns[camel] = val;
    }

    return returns;
  }

  if (style = dom.currentStyle) {
    for (var prop in style) {
      returns[prop] = style[prop];
    }

    return returns;
  }

  return this.css();
}; // http://stackoverflow.com/questions/754607/can-jquery-get-all-css-styles-associated-with-an-element/6416527#6416527


$.fn.copyCSS = function ($source) {
  var styles = $source.getStyleObject();
  this.css(styles);
  return this;
};

gtn.ui.showFullLabelText = function ($label) {
  // If the visible width of the label doesn't accommodate the entire content (scrollWidth),
  // create a mouse-over layer to display the full text and mimic the visual styles of the label.
  if ($label.outerWidth() < $label[0].scrollWidth) {
    // Create the mouse-over layer if it doesn't exist.
    var $topicMouseOver = $("#topicMouseOver");

    if ($topicMouseOver.length == 0) {
      $(".m-main-content").append("<div id='topicMouseOver'></div>");
      $topicMouseOver = $("#topicMouseOver");
    }

    if ($label.prop("tagName").toLowerCase() == "a") {
      // This is a hyperlink label. Copy the link to the mouse-over layer.
      $topicMouseOver.html("<a href='" + $label.attr("href") + "'>" + $label.text() + "</a>");
    } else {
      // This is a plain text label. Copy the text content to the mouse-over layer.
      $topicMouseOver.text($label.text());
    }

    var isFForIE = $("html").is(".k-ie, .k-ff");
    $topicMouseOver // Copy all visual styles (defined, computed or inherited) from $label to the mouse-over layer.
    // Even though using copyCSS() will introduce redundant CSS properties, it preserves the styling
    // of the different levels of topics.
    .copyCSS($label) // Apply additional CSS adjustments.
    .css({
      position: "absolute",
      width: (isFForIE ? $label[0].scrollWidth + 4 : $label[0].scrollWidth) + "px",
      height: "24px",
      left: $label.offset().left - 2 + "px",
      top: $label.offset().top - 1 + "px",
      textOverflow: "clip",
      overflow: "visible",
      maxWidth: "none",
      border: "1px solid #EBEBEB",
      zIndex: 2,
      backgroundColor: "#EBEBEB"
    }) // Make the mouse-over layer disappear on mouse-out.
    .mouseleave(function () {
      $(this).hide();
    }) // Show the layer.
    .show();
  }
};

gtn.ui.findNodeByText = function (itemNodes, targetNodeText) {
  if (targetNodeText) {
    var targetNodeText = gtn.ui.hyphenDecode(targetNodeText).toLowerCase();
    var targetNode = itemNodes.filter(function (index) {
      return $(this).find("> div > .k-in").text().toLowerCase() == targetNodeText;
    });
    return targetNode;
  } else {
    // Return all the item nodes un-filtered.
    return itemNodes;
  }
};

gtn.ui.rearrangeBookmark = function (e) {
  // Prevent users from dragging one node onto another node.
  // Note the e.statusClass is without the "k-" prefix, but setStatusClass() requires it.
  if (e.statusClass == "add") {
    // deny the operation
    e.setStatusClass("k-denied");
  }
};
/* Encode a string into URL-friendly format. */


gtn.ui.hyphenEncode = function (value) {
  // 1. Change single hyphen to double hyphens.
  // 2. Change single whitespace to single hyphen.
  // 3. URI-encode other special characters.
  return encodeURIComponent(value.replace(/-/g, "--").replace(/\s/g, "-"));
};
/* Decode a string into display-friendly format. */


gtn.ui.hyphenDecode = function (value) {
  // 1. URI-decode special characters.
  // 2. Change all hyphens to whitespaces.
  // 3. Change double spaces (originally double hyphens) to single hyphen.
  return decodeURIComponent(value).replace(/-/g, " ").replace(/\s\s/g, "-");
};

gtn.ui.addCssRule = function (stylesheet, selector, rules, index) {
  // Default to inserting the rules at the top of the stylesheet, if not specified.
  // For inserting to the end of stylesheet, use styleSheet.cssRules.length as the index.
  index = index || 0;

  if ("insertRule" in stylesheet) {
    stylesheet.insertRule(selector + "{" + rules + "}", index);
  } else if ("addRule" in stylesheet) {
    stylesheet.addRule(selector, rules, index);
  }
};

gtn.ui.showCallout = function (calloutSelector, targetSelector, calloutOrientation, adjustment) {
  var $target = $(targetSelector);
  var targetEl = $target[0];
  var targetOffset = $target.offset();
  var $callout = $(calloutSelector);
  var calloutOffset = {
    top: 0,
    left: 0
  };
  adjustment = adjustment || {};
  adjustment.top = adjustment.top || 0;
  adjustment.left = adjustment.left || 0;
  var pointerHeight = 12;
  var marginSpacing = 20; // Apply the new CSS class, so the callout size is accurate.

  $callout.addClass("callout-" + calloutOrientation);
  console.log($('body').scrollTop());

  switch (calloutOrientation) {
    case "top":
      calloutOffset.left = targetOffset.left + adjustment.left;
      calloutOffset.top = targetEl.getBoundingClientRect().top - targetEl.offsetHeight + adjustment.top;
      break;

    case "bottom":
      calloutOffset.left = targetOffset.left + adjustment.left;
      calloutOffset.top = targetEl.getBoundingClientRect().top + targetEl.offsetHeight + pointerHeight + marginSpacing + adjustment.top;
      break;

    case "right":
      calloutOffset.left = targetOffset.left + $target.outerWidth() + adjustment.left;
      calloutOffset.top = targetEl.getBoundingClientRect().top;
      break;

    case "left":
      calloutOffset.left = targetOffset.left - $callout.outerWidth() + adjustment.left;
      calloutOffset.top = targetEl.getBoundingClientRect().top;
      break;
  } // Adjust the pointer position of the callout, if requested and if it's allowed.


  if (adjustment.pointer) {
    // Create a new local stylesheet for inserting new rules.
    var styleTag = document.createElement('style');
    document.head.appendChild(styleTag);
    var styleSheet = styleTag.sheet || styleTag.styleSheet;

    switch (calloutOrientation) {
      case "top":
      case "bottom":
        // Only the left position of the pointer is allowed to be adjusted; top position is fixed.
        var newLeftPos = adjustment.pointer.left;

        if (newLeftPos && 0 <= newLeftPos && newLeftPos <= $callout.outerWidth()) {
          var currentLeftPosStr = window.getComputedStyle($callout[0], ':before').getPropertyValue('left');
          var newLeftPosStr = newLeftPos + "px";

          if (currentLeftPosStr != newLeftPosStr) {
            var newCssRule = 'left: ' + newLeftPosStr + ' !important;';
            gtn.ui.addCssRule(styleSheet, calloutSelector + ':before', newCssRule);
            gtn.ui.addCssRule(styleSheet, calloutSelector + ':after', newCssRule);
          }
        }

        break;

      case "right":
      case "left":
        // Only the top position of the pointer is allowed to be adjusted; left position is fixed.
        var newTopPos = adjustment.pointer.top;

        if (newTopPos && 0 <= newTopPos && newTopPos <= $callout.outerHeight()) {
          var currentTopPosStr = window.getComputedStyle($callout[0], ':before').getPropertyValue('top');
          var newTopPosStr = newTopPos + "px";

          if (currentTopPosStr != newTopPosStr) {
            var newCssRule = 'top: ' + newTopPosStr + ' !important;';
            gtn.ui.addCssRule(styleSheet, calloutSelector + ':before', newCssRule);
            gtn.ui.addCssRule(styleSheet, calloutSelector + ':after', newCssRule);
          }
        }

        break;
    }
  }

  $callout.css("top", "auto") // Reset the top value before the offset() call.
  .css("left", "auto") // Reset the left value before the offset() call.
  .offset(calloutOffset).css("position", "fixed").show();
};

if (typeof Prism === 'undefined') {
  window.Prism = {
    languages: {},
    hightlightAll: function hightlightAll() {
      console.warn('Prism.js has been blocked by your add blocker');
    }
  };
}
/*
    Get Started Tutorial
 */


$(document).on('bind-events-to-axml-page', function () {
  // Check if user has visited the start guide landing page.
  var visited = Cookies.get('start-guide-visited');
  var isStartPage = location.pathname === '/start';

  if (isStartPage) {
    // Show the prompt for first-time visitors.
    if (visited !== 'yes') {
      $('#FirstTimeUserPrompt').show();
      $(document).trigger('article:heightChange');
    } // Flag the start guide landing page as visited.


    Cookies.set('start-guide-visited', 'yes', {
      secure: true
    });
  }
});
module.exports = window.gtn = gtn;

/***/ })

/******/ });


// WEBPACK FOOTER //
// gtadmin.bundle.js